/**
 * Photoswipe 5
 */
import PhotoSwipeLightbox from 'photoswipe/lightbox'

// Init with options
// see https://photoswipe.com/documentation/options.html
const galleries = Array.from(document.getElementsByClassName('js-photoswipe'))

for (const gallery of galleries) {
  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children: 'a',
    pswpModule: () => import('photoswipe'),
  })
  lightbox.init();

  const additionalImgs = gallery.dataset.additionalImgs;

  if (additionalImgs) {
    const newImgs = JSON.parse(gallery.dataset.additionalImgs).reverse();

    // Once it opens, calculate the nb of items (numItems) & add the nb of additional elements from the newImgs array
    lightbox.addFilter('numItems', (numItems) => {
      return numItems + newImgs.length;
    });

    // For each new item: once the lightbox opens, add the newImgs at the end
    for (let i = 0; i < newImgs.length; i++) {
      lightbox.addFilter('itemData', (itemData, index) => {
        if (index === lightbox.getNumItems() - (i + 1)) {
          return newImgs[i];
        }

        return itemData;
      });
    }
  }
  const galleryToggles = document.querySelectorAll('.js-btn-open-photoswipe');

  galleryToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      lightbox.loadAndOpen(0, { gallery });
    })
  })
}
